import { Validators } from '@angular/forms';


export const VisitPlanFields = {
   best_date: ['', [Validators.required, Validators.minLength(1)]],
}
